export const MOBILE_MAX_WIDTH = 767
export const TABLET_MAX_WIDTH = 1349
export const SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH = 1023

export const NAV_COLLAPSE_MIN_WIDTH = {
  default: 1256,
  marketing: 1280,
} satisfies Record<NavigationContext, number>

function matchesQuery(query: string): boolean {
  return import.meta.client && !!window.matchMedia(query).matches
}

export function isMobileViewport(): boolean {
  return matchesQuery(`(max-width: ${MOBILE_MAX_WIDTH}px)`)
}

export function isTabletViewport(): boolean {
  return matchesQuery(`(min-width: ${MOBILE_MAX_WIDTH + 1}px) and (max-width: ${TABLET_MAX_WIDTH}px)`)
}

export function isDesktopViewport(): boolean {
  return matchesQuery(`(min-width: ${TABLET_MAX_WIDTH + 1}px)`)
}

export function isNarrowTabletViewport(): boolean {
  return matchesQuery(`(min-width: ${MOBILE_MAX_WIDTH + 1}px) and (max-width: ${SIDEBAR_AUTO_COLLAPSE_MAX_WIDTH}px)`)
}
